export default __webpack_public_path__ + "static/media/T344_SOV.36f6b85a.pdf";